import { FooterContent } from './loaders';

export const Footer = () => <FooterContent />;
